<template>
  <div class="winners-highlights-section__wrapper">
    <h2 class="winners-highlights-section__title title uppercase">
      Finance Awards 2025 Highlights
    </h2>

    <p class="winners-highlights-section__text text-body title-border">
      Take a look back at the event’s best moments
    </p>

    <winners-highlights-slider
      :slides="highlightsPairs"
      class="winners-highlights-section__highlights"
    />
  </div>
</template>

<script>
import { HTML_TAG } from '@fmpedia/enums'
import WinnersHighlightsSlider from './WinnersHighlightsSlider'
import { HIGHLIGHTS } from 'sections/_winners/enums'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
// import scss from '@/utils/scss'
// const { breakpoints, breakpointNames } = scss

export default {
  name: 'HomepageWinnersSection',
  mixins: [hydrationHelpers],
  components: { WinnersHighlightsSlider },
  consts: { HTML_TAG },
  data() {
    return {
      highlights: HIGHLIGHTS
    }
  },
  computed: {
    highlightsPairs() {
      return this.highlights.map(value => [value])
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/scss/local/mixins/grid';

.winners-highlights-section__wrapper {
  padding: 58px 0;

  @include mobile {
    padding-bottom: 64px;
  }

  .winners-highlights-section__text {
    margin-top: 10px;
    padding-bottom: 32px;

    @include mobile {
      margin-top: 24px;
    }
  }

  $border-radius: 12px;
  .winners-highlights-section__item-wrapper {
    border-radius: $border-radius;
    padding: 1px;
    background: linear-gradient(180deg, $c--blue-dark, $c--gray);
  }

  .winners-highlights-section__highlights {
    margin-top: 48px;

    @include desktop-md {
      margin-top: 32px;
    }
  }
}
</style>
